import { render, staticRenderFns } from "./TabsList.vue?vue&type=template&id=f5231afe&scoped=true&"
import script from "./TabsList.vue?vue&type=script&lang=js&"
export * from "./TabsList.vue?vue&type=script&lang=js&"
import style0 from "./TabsList.vue?vue&type=style&index=0&id=f5231afe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5231afe",
  null
  
)

export default component.exports